export default __webpack_public_path__ + "static/media/linkdin.69f4ab53.png";